'use client'

import { toast } from "@/lib/toast"
import { useAddressForm } from "@/lib/commerce/hooks"
import CenterModal from "../elements/CenterModal"
import { AddressFormFields, solidButton } from "./AddressList"

interface AddressEditProps {
  open: boolean
  setOpen: (open: boolean) => void
  address: any
  addressField: any
  vendor?: any
  updateAddress: (id: string, body: any) => Promise<boolean>
  submitting: boolean
}

export default function AddressEdit({ open, setOpen, address, addressField, vendor, updateAddress, submitting }: AddressEditProps) {
  const form = useAddressForm({ addressField, vendor, initial: address })

  const handleSave = async () => {
    const v = form.validate()
    if (!v.ok) return toast.error(v.error)
    const ok = await updateAddress(address.id, form.compose())
    if (ok) setOpen(false)
  }

  return (
    <CenterModal
      open={open}
      onClose={() => setOpen(false)}
      title="Хаяг засах"
      footer={
        <div className="flex justify-end">
          <button type="button" onClick={handleSave} disabled={submitting} className={solidButton}>{submitting ? 'Хадгалж байна…' : 'Хадгалах'}</button>
        </div>
      }
    >
      <AddressFormFields form={form} />
    </CenterModal>
  )
}
